export default {
    props: ["title", "value"],
    template: /*html*/`
    <div class="border-b-[1px] border-b-black/5 last:border-b-0 flex">
        <div class="p-6 px-8 w-[23rem] font-bold flex-shrink-0">{{ title }}</div>
        <div class="p-6 px-8 border-l-[1px] border-l-black/5">{{ value }}</div>
    </div>
    `
}